import { GetRelativesQuery, relativeDef } from "@skbkontur/staff-common";
import { Toast } from "react-ui";

import { CandyThunkAction } from "../../../Engine/Core/Store/CandyReduxTypes";
import { getCandyHub } from "../../../Forms/Sentry/InitializeSentry";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { AbsoluteModelPath, AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { BindingPath } from "../../../Engine/Core/CoreTypes";

import { EmployeeRelativesActionType } from "./EmployeeRelativesAction";

export const importRelatives =
    (
        viewModelSelect: ViewModelSelect,
        bindingPath: AbsoluteResolvedModelPath,
        employeeIdPath?: BindingPath | AbsoluteModelPath,
        query?: GetRelativesQuery
    ): CandyThunkAction<Promise<relativeDef[]>> =>
    async (dispatch, getState, form): Promise<relativeDef[]> => {
        try {
            const employeeId = viewModelSelect.controlModel(getState(), employeeIdPath ?? "").value;
            if (employeeId) {
                const relativesResponse = await form.staffClient.getRelatives(employeeId, query);
                dispatch({
                    type: EmployeeRelativesActionType.CompleteLoading,
                    payload: {
                        path: bindingPath.toLegacyPath(),
                        relatives: relativesResponse.items,
                    },
                });
                return relativesResponse.items;
            } else {
                dispatch({
                    type: EmployeeRelativesActionType.CompleteLoading,
                    payload: {
                        path: bindingPath.toLegacyPath(),
                        relatives: [],
                    },
                });
            }
        } catch (e) {
            Toast.push("Ошибка при получении списка родственников");
            // eslint-disable-next-line no-console
            console.error(e);
            getCandyHub().captureException(e);
        }

        return [];
    };
